import { forwardRef } from 'react';
import {
  Tooltip as MantineTooltip,
  type TooltipProps as MantineTooltipProps,
} from '@mantine/core';

export type TooltipProps = MantineTooltipProps;

/**
 * Tooltip component that wraps Mantine Tooltip with sensible defaults.
 * Forwards refs so it works correctly inside Mantine compound components
 * like Menu.Target that rely on ref-based positioning.
 *
 * @example
 * ```tsx
 * import { Tooltip } from '@caddie/ui-kit';
 *
 * <Tooltip label="Tooltip content">
 *   <Button>Hover me</Button>
 * </Tooltip>
 * ```
 */
export const Tooltip = forwardRef<HTMLDivElement, TooltipProps>(
  (props, ref) => {
    return <MantineTooltip ref={ref} {...props} />;
  }
);

Tooltip.displayName = 'Tooltip';
